import InputNumber from './src/main'

InputNumber.install = function (Vue) {
    Vue.components(InputNumber.name, InputNumber)
}

export default InputNumber